import { useEffect, useState } from "react";

import { fetchCellars, fetchSuggestions } from "./api.js";

/**
 * The countries the reader's cellars hold wine from, for a picker outside any
 * one cellar — *Upptäck*'s wish form and the administrator's run form. Asked
 * for on 2026-09-29: those countries first, the rest after, each group in
 * alphabetical order (`orderCountries`).
 *
 * Every cellar the reader reaches, read through the same suggestions the
 * wine form uses, which any reader of a cellar may fetch. Empty until they
 * arrive, and empty if they fail: the picker is then simply alphabetical,
 * which is a complete answer and not a broken one.
 */
export function useCellarCountries(): string[] {
  const [countries, setCountries] = useState<string[]>([]);

  useEffect(() => {
    let current = true;
    void fetchCellars()
      .then(({ cellars }) =>
        Promise.all(
          cellars.map((cellar) =>
            fetchSuggestions(cellar.id)
              .then((suggestions) => suggestions.countries.map((row) => row.countryCode))
              // One cellar that cannot be read leaves the others' countries.
              .catch(() => [] as string[]),
          ),
        ),
      )
      .then((lists) => {
        if (current) setCountries([...new Set(lists.flat())]);
      })
      .catch(() => undefined);
    return () => {
      current = false;
    };
  }, []);

  return countries;
}
